
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

interface FortuneMessageProps {
  fortune: string;
  onClose: () => void;
}

const FortuneMessage = ({ fortune, onClose }: FortuneMessageProps) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Reset visibility when a new fortune is shown
    setIsVisible(true);
  }, [fortune]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 500); // Allow animation to complete before calling onClose
  };

  if (!fortune) return null;

  return (
    <motion.div
      className="fixed inset-0 flex items-center justify-center z-50 bg-black/20 backdrop-blur-sm"
      initial={{ opacity: 0 }}
      animate={{ opacity: isVisible ? 1 : 0 }}
      transition={{ duration: 0.3 }}
      onClick={handleClose}
    >
      <motion.div
        className="fortune-paper paper-texture max-w-md w-full mx-4 p-8 rounded-lg text-center relative"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: isVisible ? 1 : 0 }}
        transition={{ type: "spring", damping: 15, stiffness: 300 }}
        onClick={(e) => e.stopPropagation()}
      >
        <Star className="text-yellow-500 mx-auto mb-4" />
        <p className="text-gray-700 italic font-light text-lg mb-6">{fortune}</p>
        <div className="text-xs text-gray-500 mt-4">Your fortune for today</div>
        
        <motion.button
          className="mt-6 px-4 py-2 bg-black/5 hover:bg-black/10 rounded-full text-sm transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleClose}
        >
          Close
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default FortuneMessage;
